module.exports = __webpack_public_path__ + "static/scale-model-of-goodyear-airship-operations-in-torrance-california-cc62fae5e41bc4d2de15f5f658c5b904.png";